// extracted by mini-css-extract-plugin
export default {"sliderContainer":"slider_sliderContainer__Ylj5C","sliderSteps":"slider_sliderSteps__gst-z","sliderStep":"slider_sliderStep__f0D6Y"};